<!-- 生成个人印章 -->
import { clearInterval } from 'timers';
<template>
    <el-dialog :visible.sync="visible"
               class="create-personal-seal"
               width="480px"
               :before-close="doClose">
        <el-tabs v-model="activeName"
                 slot="title"
                 class="create-seal-tab">
            <el-tab-pane label="扫码手写"
                         name="qr">
            </el-tab-pane>
            <el-tab-pane label="自动生成"
                         name="auto"></el-tab-pane>
            <el-tab-pane label="上传图片"
                         name="upload"></el-tab-pane>
        </el-tabs>

        <template v-if="activeName === 'qr'">
            <div class="qr-code-box">
                <img :src="`${BASE_APP_PATH}/seal/qr`"
                     alt="">
            </div>
            <p class="tip small-font text-center">手机扫一扫，绘制个人签名</p>
        </template>

        <div v-else-if="activeName === 'auto'"
             class="auto-content">
            <label class="seal-example"
                   :class="{ 'active': sealType == type.label }"
                   v-for="(type, index) in sealTypes"
                   :key="index">
                <div class="image-box">
                    <img :src="type.src"
                         alt="">
                </div>
                <el-radio v-model="sealType"
                          :label="type.label">
                    <span class="black-text">{{type.name}}</span>
                </el-radio>
            </label>
        </div>

        <div v-else>
            <el-upload class="upload-component-personal form-item-width"
                       drag
                       action
                       :show-file-list="false"
                       accept="image/png, image/jpeg, image/jpg"
                       :before-upload="uploadImg">
                <template v-if="imgUrl">
                    <img :src="imgUrl"
                         class="middle-center"
                         alt>
                    <div class="img-model transfrom-center">
                        <div class="text-center">
                            <i class="iconicon-yyz-n upload-icon white-text"></i>
                            <p>重新上传</p>
                        </div>
                    </div>
                </template>
                <template v-else>
                    <svg-icon id="iconperson-sign"
                              style="font-size: 40px"
                              class="upload-icon"></svg-icon>
                    <div class="el-upload__text">
                        将个人签字图片拖到此处，或
                        <em>点击上传</em>
                    </div>
                </template>

                <div class="el-upload__tip tip small-text text-center"
                     slot="tip">支持图片格式：jpg、jpeg、png</div>
            </el-upload>
        </div>

        <div slot="footer"
             v-if="activeName == 'auto'">
            <el-button type="default"
                       size="medium"
                       @click="doClose">取 消</el-button>
            <el-button type="primary"
                       @click="doConfirm"
                       size="medium">确 认</el-button>
        </div>

        <!-- 裁剪 -->
        <el-dialog :visible.sync="showCropper"
                   v-if="showCropper"
                   title="图片裁剪"
                   append-to-body
                   :close-on-click-modal="false"
                   :close-on-press-escape="false"
                   width="1100px">
            <cropper :img-url="imgUrl"
                     seal-type="personal"
                     data-type="base64"
                     :specs="sealOptions"
                     @onSaveImage="doSaveImage"
                     @onCancel="doCancel"></cropper>
        </el-dialog>
    </el-dialog>
</template>

<script>
import SvgIcon from "@/components/svg-icon.vue";
import Cropper from "@/components/croper/index.vue";

export default {
    components: { Cropper, SvgIcon },
    data () {
        return {
            activeName: 'qr',
            timer: 0,
            sealType: 'SQUARE',
            sealTypes: [
                { label: 'SQUARE', src: require('../../../assets/images/seal/seal-example-00.png'), name: '样式一' },
                { label: 'RECTANGLE', src: require('../../../assets/images/seal/seal-example-01.png'), name: '样式二' },
            ],
            imgUrl: '',
            showCropper: false,
            // 印章规格
            sealOptions: [
                {
                    height: 16,
                    key: "REACTANGLE_40_16",
                    label: "矩形（40mm * 16mm）",
                    type: "REACTANGLE_42",
                    width: 40
                }
            ]
        };
    },
    props: {
        visible: Boolean
    },
    mounted () {
        this.getSealSpecs();
        this.handleProgress();
    },
    methods: {
        doClose () {
            this.$emit('update:visible', false);
        },

        /**
      * 上传图片
      */
        uploadImg (file) {
            let type = file.name.split(".")[1].toUpperCase();
            let types = ["JPG", "PNG", "JPEG", "GIF"];
            let img = file.size ? file : file.target.files[0];
            const isLt5M = img.size / 1024 / 1024 < 5;

            if (!types.includes(type)) {
                this.$message.error("文件仅支持png，jpg，gif，jpeg格式！");
                return false;
            }

            if (!isLt5M) {
                this.$message.error("上传图片大小不能超过 5MB！");
                return false;
            }

            let reader = new FileReader();
            reader.onload = e => {
                let data;
                if (typeof e.target.result === 'object') {
                    data = window.URL.createObjectURL(new Blob([e.target.result]));
                } else {
                    data = e.target.result;
                }
                this.imgUrl = data;
                this.showCropper = true;
            };
            reader.readAsArrayBuffer(img);
            return false;
        },

        async doSaveImage (spec, imgBase64) {
            let loading = this.$loading({ text: '图片上传中...' });
            try {
                let formdata = new FormData();
                formdata.append('imgBase64', imgBase64);
                formdata.append('transparen', true);
                formdata.append('zoom', true);
                formdata.append('rotate', false);
                let URL = "/seal/applyseal";
                let resp = await this.axios.post(URL, formdata);
                resp = resp.data;
                if (resp.code === 0) {
                    this.handleProgress();
                } else {
                    this.$message.error(resp.message);
                }
            } catch (error) {
                console.log(error);
            } finally {
                loading.close();
            }
        },

        doCancel () {
            this.imgUrl = '';
            this.showCropper = false;
        },


        doConfirm () {
            this.$emit('onConfirm', this.sealType);
        },

        handleProgress () {
            this.getPaintStatus();
            this.timer = setInterval(() => {
                this.getPaintStatus();
            }, 5000);
        },

        /**
         * 获取扫码状态
         */
        async getPaintStatus () {
            try {
                let resp = await this.axios({
                    url: '/seal/download/img',
                    method: 'GET',
                    params: { imgKey: 'QRCODE' }
                });
                resp = resp.data;
                if (resp.code === 0 && resp.result) {
                    clearInterval(this.timer);
                    this.doClose();
                    this.$emit('updateImg');
                }
            } catch (error) {
                console.log(error);
            }
        },

        async getSealSpecs () {
            try {
                let resp = await this.axios({
                    url: '/seal/person/style/show',
                    method: 'GET'
                });
                resp = resp.data;
                if (resp.code === 0) {
                    this.sealTypes[0].src = `data:image/png;base64,${resp.square}`;
                    this.sealTypes[1].src = `data:image/png;base64,${resp.rectangle}`;
                }
            } catch (error) {
                console.log(error);
            }
        },
    },
    beforeDestroy () {
        clearInterval(this.timer);
    }
};
</script>

<style lang="less" scoped>
.create-personal-seal {
    .qr-code-box {
        width: 180px;
        margin: 20px auto;
        padding: 5px;
        border: 1px solid @border-color-base;
    }

    .image-box {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 160px;
        height: 160px;
        padding: 5px;
        margin-bottom: 20px;
        border: 1px solid @border-color-base;
        cursor: pointer;

        img {
            width: 160px;
        }
    }

    .auto-content {
        display: flex;
        justify-content: center;
    }

    .seal-example {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        width: 160px;

        & + .seal-example {
            margin-left: 40px;
        }

        &.active .image-box {
            border-color: @red;
        }
    }
}
</style>

<style lang="less">
.create-personal-seal {
    .el-dialog__footer {
        border-top: 1px solid @border-color-base;
    }

    .upload-component-personal {
        .el-upload-dragger {
            width: 440px;
            padding-top: 45px;
        }
    }
}
.create-seal-tab {
    .el-tabs__header {
        margin: 0;
    }

    .el-tabs__item {
        height: auto;
        line-height: 1.4134;
        padding-bottom: 10px;
        font-size: 16px;
    }
}
</style>


